module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-table-height"
  }, [_c('table', {
    staticClass: "table table-hover table-border"
  }, [_c('caption', {
    staticClass: "table-caption"
  }, [_c('span', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.tableTitle))]), _c('a', {
    staticClass: "pull-right bid-info-span",
    attrs: {
      "href": "purchase.html"
    }
  }, [_vm._v("更多>")]), _vm._v(" "), _c('ul', {
    staticClass: "list-basic-settings classify-List"
  }, _vm._l((_vm.tableContent), function(item, index) {
    return _c('li', [_c('span', {
      staticClass: "bid-info-span",
      class: {
        active: _vm.active == index
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  }), 0)]), _vm._v(" "), _c('tbody', {
    staticClass: "show-limit"
  }, [(_vm.infos && _vm.infos instanceof Array) ? [_vm._l((_vm.infos), function(info) {
    return _c('tr', {
      staticClass: "normal",
      on: {
        "click": function($event) {
          return _vm.seeDetails(info)
        }
      }
    }, [_c('td', {
      attrs: {
        "width": "12%"
      }
    }, [(info.messageType == '招标公告') ? [_c('span', {
      staticClass: "state state-bid"
    }, [_vm._v(_vm._s(info.messageType))])] : (info.messageType == '竞价公告') ? [_c('span', {
      staticClass: "state state-other"
    }, [_vm._v(_vm._s(info.messageType))])] : (info.messageType == '招标') ? [_c('span', {
      staticClass: "state state-enquiry"
    }, [_vm._v(_vm._s(info.messageType))])] : (info.messageType == '中标通知') ? [_c('span', {
      staticClass: "state state-bidding"
    }, [_vm._v(_vm._s(info.messageType))])] : [_c('span', {
      staticClass: "state state-other"
    }, [_vm._v(_vm._s(info.messageType))])]], 2), _vm._v(" "), _c('td', {
      staticClass: "limitText",
      attrs: {
        "width": "25%",
        "title": info.messageTitle
      }
    }, [_c('div', {
      staticClass: "setMargin"
    }, [_vm._v(_vm._s(info.messageTitle))])]), _vm._v(" "), _c('td', {
      staticClass: "limitText",
      attrs: {
        "width": "28%",
        "title": info.messageContent
      }
    }, [_c('div', {
      staticClass: "setMargin"
    }, [_vm._v(_vm._s(_vm.datatype == "area" ? info.purOrgName : info.messageContent))])]), _vm._v(" "), (info.status) ? [_c('td', {
      staticClass: "btn-action",
      attrs: {
        "width": "14%"
      }
    }, [(info.status === '1') ? [_c('span', [_vm._v("报名未开始")])] : (info.status === '3') ? [_c('span', [_vm._v("报名已结束")])] : (info.status === '-1') ? [_c('span', [_vm._v("招标已结束")])] : (info.status === '4') ? [_c('span', [_vm._v("投标进行中")])] : (info.status === '5') ? [_c('span', [_vm._v("投标已结束")])] : [_c('span', [_vm._v("报名进行中")])]], 2)] : [_c('td', {
      staticClass: "btn-action",
      attrs: {
        "width": "14%"
      }
    }, [(_vm.now < _vm.timeFormat(info.publishTime)) ? [_c('span', [_vm._v("报名未开始")])] : (_vm.now > _vm.timeFormat(info.deadline)) ? [_c('span', [_vm._v("报名已结束")])] : [_c('span', [_vm._v("报名进行中")])]], 2)], _vm._v(" "), _c('td', {
      staticClass: "td-text-right",
      attrs: {
        "width": "21%"
      }
    }, [_c('span', {
      attrs: {
        "id": "setMargin"
      }
    }, [_vm._v("截止时间："), _c('br'), _vm._v(_vm._s(info.deadline))])])], 2)
  }), _vm._v(" "), (_vm.infos.length < 6) ? _vm._l(((6 - _vm.infos.length)), function(info) {
    return _c('tr', {
      staticClass: "supplement"
    }, [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(" ")])])
  }) : _vm._e()] : [_c('p', {
    staticClass: "error-handling"
  }, [_vm._v("暂无数据")])]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3f6f814!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info-table.vue
// module id = 183
// module chunks = 4 9